import { render, staticRenderFns } from "./cambioPrecio.vue?vue&type=template&id=78249106&scoped=true&"
import script from "./cambioPrecio.vue?vue&type=script&lang=js&"
export * from "./cambioPrecio.vue?vue&type=script&lang=js&"
import style0 from "./cambioPrecio.vue?vue&type=style&index=0&id=78249106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78249106",
  null
  
)

export default component.exports